import React, { useState, useEffect } from "react";
import Button from "./Button";
import Modal from "./Modal";

import TextInput from "./Input/TextInput";
import Selectpicker from "./Input/Selectpicker";
import FeedbackModal from "./FeedbackModal";

import "assets/css/Contact.min.css";
import req from "functions/req";
import settings from "configs/settings";
import clg from "functions/log";
import validator from "functions/validator";
import getCaptchaToken from "functions/getCaptchaToken";
import modifyState from "functions/modifyState";
import ConfirmGDPR from "components/ConfirmGDPR";

const ContactContent = ({
  apartmentCodes,
  selectedApartment,
  sendForm,
  showValidationStatus,
  buttonContainerClasses,
  buttonLoaderState,
}) => {
  const [form, setForm] = useState({
    property_id: selectedApartment ? [selectedApartment.value] : [],
    first_name: {
      value: null,
      validation: false,
    },
    last_name: {
      value: null,
      validation: false,
    },
    email: {
      value: null,
      validation: false,
    },
    phone: {
      value: null,
      validation: false,
    },
    message: {
      value: null,
      validation: false,
    },
    gdpr: {
      value: false,
      validation: false,
    },
  });

  useEffect(() => {
    clg("FORM: ", form);
  }, [form]);

  const handleInputChange = (value, field) => {
    setForm({
      ...form,
      [field]: value,
    });
  };

  return (
    <div className="row">
      {apartmentCodes && (
        <div className="col-12 input-field-container apartment">
          <Selectpicker
            defaultValue={selectedApartment ? selectedApartment : null}
            title="Az alábbi lakásokkal kapcsolatban szeretnék érdeklődni:"
            isMulti
            name="apartment"
            options={apartmentCodes}
            placeholder="Lakások kiválasztása"
            className="select-apartment"
            classNamePrefix="select"
            onChange={(selected) => {
              let selectedValues = [];
              selected.map((curr) => {
                selectedValues.push(curr.value);
              });
              handleInputChange(selectedValues, "property_id");
            }}
          />
        </div>
      )}

      <div className="col-sm-6 input-field-container last-name">
        <TextInput
          type="text"
          label="Vezetéknév"
          onChange={(e) => {
            setForm({
              ...form,
              last_name: {
                value: e.value,
                validation: e.validation.status,
              },
            });
          }}
          show_validation_status={showValidationStatus}
          required
        />
      </div>
      <div className="col-sm-6 input-field-container first-name">
        <TextInput
          type="text"
          label="Keresztnév"
          onChange={(e) => {
            setForm({
              ...form,
              first_name: {
                value: e.value,
                validation: e.validation.status,
              },
            });
          }}
          show_validation_status={showValidationStatus}
          required
        />
      </div>
      <div className="col-12 input-field-container email">
        <TextInput
          type="email"
          label="E-mail cím"
          onChange={(e) => {
            setForm({
              ...form,
              email: {
                value: e.value,
                validation: e.validation.status,
              },
            });
          }}
          conditions={{
            validationType: "email",
          }}
          show_validation_status={showValidationStatus}
          required
        />
      </div>
      <div className="col-12 input-field-container phone">
        <TextInput
          type="tel"
          label="Telefonszám"
          onChange={(e) => {
            setForm({
              ...form,
              phone: {
                value: e.value,
                validation: e.validation.status,
              },
            });
          }}
          conditions={{
            validationType: "phone",
          }}
          show_validation_status={showValidationStatus}
          required
        />
      </div>
      <div className="col-12 input-field-container message">
        <TextInput
          type="text"
          label="Üzenet"
          multiline
          onChange={(e) => {
            setForm({
              ...form,
              message: {
                value: e.value,
                validation: e.validation.status,
              },
            });
          }}
          conditions={{
            minLength: 3,
          }}
          show_validation_status={showValidationStatus}
          required
          minRows={5}
          maxRows={10}
        />
      </div>

        <div className="col-12 gdprContainer">
            <ConfirmGDPR
                showValidationState={showValidationStatus}
                onChange={(e) =>
                setForm({
                    ...form,
                    gdpr: {
                    value: e.value,
                    validation: e.validation.decision,
                    }, 
                })
                }
            />
        </div>

      <div
        className={`col-12 d-flex${
          buttonContainerClasses && " " + buttonContainerClasses
        }`}
      >
        <Button
          text="Elküldés"
          loader={buttonLoaderState}
          className="btn-secondary small-icon"
          icon="fas fa-paper-plane"
          onClick={() => {
            sendForm(form);
          }}
        />
      </div>
    </div>
  );
};

/**
 * @param {string} viewType - inContent / modal
 */

const Contact = ({ selectedApartment = null, viewType = "inContent" }) => {
  const [modalState, setModalState] = useState(false);
  const [apartmentCodes, setApartmentCodes] = useState([]);
  const [defaultApartmentCodes, setDefaultApartmentCodes] = useState([]);
  const [showValidationStatus, setShowValidationStatus] = useState(0);
  const [buttonLoaderState, setButtonLoaderState] = useState(0);
  const [forceFormRender_count, setForceFormRender_count] = useState(0);
  const [feedback, setFeedback] = useState({
    open: false,
    success: false,
    title: null,
    text: null,
  });

  const getApartmentCodes = () => {
    req({
      method: "POST",
      url: settings.req.allProperties,
      data: { filterBy: "code", direction: "ASC", only_code: true },
    }).then(function (res) {
      //clg("contact codes res",res)
      if (res && res.success) {
        let apCodes = [];
        [...res.data].map(function (curr) {
          apCodes.push({ value: curr.code, label: "Lakás - " + curr.code });
        });
        setApartmentCodes(apCodes);
        setDefaultApartmentCodes(apCodes);
      }
    });
  };

  useEffect(() => {
    if (viewType !== "modal") {
      getApartmentCodes();
    }
  }, []);

  const cleanup = () => {
    setModalState(false);
    setApartmentCodes(defaultApartmentCodes);
    setShowValidationStatus(0);
    setButtonLoaderState(0);
  };

  const openModal = () => {
    setModalState(true);
    getApartmentCodes();
  };

  const sendForm = (form) => {
    if (validator.getFullValidity(form).decision) {
      //Ha a mezők validak.
      setButtonLoaderState(1);

      const _form = validator.removeValidationFields(form);

      getCaptchaToken().then(function (token) {
        const objToSend = {
          ..._form,
          captcha: token,
        };
        clg("SEND: ", objToSend);

        req({ method: "POST", url: settings.req.contact, data: objToSend })
          .then(function (res) {
            clg("CONTACT RES: ", res);
            if (res && res.success) {
              modifyState(feedback, setFeedback, {
                open: true,
                success: true,
                text: "Az üzenet elküldése sikeresen megtörtént. Kollégáink hamarosan felveszik Önnel a kapcsolatot.",
              });
              cleanup();
              if (viewType === "inContent") {
                setForceFormRender_count(forceFormRender_count + 1);
              }
            } else {
              modifyState(feedback, setFeedback, {
                open: true,
                success: false,
                text: "Az üzenet elküldése során hiba történt. Próbálja újra!",
              });
            }
            setButtonLoaderState(0);
          })
          .catch((err) => {
            modifyState(feedback, setFeedback, {
              open: true,
              success: false,
              text: "Az üzenet elküldése során hiba történt. Próbálja újra!",
            });
            setButtonLoaderState(0);
          });
      });
    } else {
      modifyState(feedback, setFeedback, {
        open: true,
        success: false,
        text: "A pirossal jelölt mezők kitöltése nem megfelelő.",
      });
      setShowValidationStatus(1);
    }
  };

  return (
    <>
      {viewType === "modal" && (
        <>
          <Button
            text="Ajánlatot kérek"
            className="btn-secondary large full-width mb-3"
            icon="far fa-comment-dots"
            onClick={() => openModal()}
          />

          <Modal
            state={modalState}
            setState={setModalState}
            title="Ajánlatkérés"
            bodyClassName="contact-container contact-modal"
            hideFooter={true}
            closeCallback={() => cleanup()}
          >
            <ContactContent
              apartmentCodes={apartmentCodes}
              selectedApartment={selectedApartment}
              sendForm={sendForm}
              showValidationStatus={showValidationStatus}
              buttonContainerClasses="justify-content-center"
              buttonLoaderState={buttonLoaderState}
            />
          </Modal>
        </>
      )}

      {viewType === "inContent" && (
        <ContactContent
          apartmentCodes={apartmentCodes}
          sendForm={sendForm}
          showValidationStatus={showValidationStatus}
          buttonContainerClasses="justify-content-center"
          buttonLoaderState={buttonLoaderState}
          key={`inContentContact-${forceFormRender_count}`}
        />
      )}

      <FeedbackModal
        open={feedback.open}
        success={feedback.success}
        title={feedback.title}
        text={feedback.text}
        defaultState={feedback}
        setDefaultState={setFeedback}
      />
    </>
  );
};

export default Contact;
